import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Helpers } from '../../../Helpers';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import 'highcharts/modules/funnel';
import Loader from "../../../Components/Loader";
import { Utils } from '../../../Utils';
import dayjs from 'dayjs';
import ReactECharts from "echarts-for-react";
import { ResponsiveFunnel } from '@nivo/funnel';

const FunnelChart = ({ data = {}, isStatic = false }) => {

  const defaultStages = [
    { id: 1, stageName: "Qualification", probability: 10, dealCategory: "Open", forecastCategory: "Pipeline" },
    { id: 2, stageName: "Need Analysis", probability: 20, dealCategory: "Open", forecastCategory: "Pipeline" },
    { id: 3, stageName: "Value Proposition", probability: 40, dealCategory: "Open", forecastCategory: "Pipeline" },
    { id: 4, stageName: "Identify Decision Makers", probability: 60, dealCategory: "Open", forecastCategory: "Pipeline" },
    { id: 5, stageName: "Proposal/Price Quote", probability: 75, dealCategory: "Open", forecastCategory: "Pipeline" },
    { id: 6, stageName: "Negotiation/Review", probability: 90, dealCategory: "Open", forecastCategory: "Pipeline" },
    { id: 7, stageName: "Closed Won", probability: 100, dealCategory: "Closed Won", forecastCategory: "Closed" },
    { id: 8, stageName: "Closed Lost", probability: 0, dealCategory: "Closed Lost", forecastCategory: "Omitted" },
    { id: 9, stageName: "Closed Lost to Competition", probability: 0, dealCategory: "Closed Lost", forecastCategory: "Omitted" }
  ];

  let getOptions = (datas = []) => {
    let reorderedData = data?.grouping_options?.map(stage => datas?.find(item => item?.name === stage))?.filter(Boolean);
    let transformedData1 = (reorderedData?.length > 0 ? reorderedData : datas)?.filter(x => (x?.name !== "Closed Won" && x?.name !== "Closed Lost"));
    let transformedData = transformedData1?.map((item) => ([item.name, item.value]));
    if (transformedData1?.length > 0) {
      const allNames = transformedData1.map(item => item.name?.toLowerCase());
      let funnelColor = null;

      if (allNames.every(name => name === "7")) {
        funnelColor = "#00B050";
      } // else if (allNames.every(name => name === "closed lost")) {
      //   funnelColor = "#dc3545";
      // }

      const colors = funnelColor
        ? Array(transformedData1.length).fill(funnelColor)
        : Highcharts.getOptions().colors;

      const updated = transformedData1.map(item => {
        const match = defaultStages.find(stage => stage.id === Number(item.name));
        return [match ? match.stageName : item.name, item.value];
      });

      // const updated = transformedData1?.map(item => {
      //   const matchedStage = defaultStages.find(stage => stage.id === Number(item.name));
      //   debugger
      //   return {
      //     ...item,
      //     name: matchedStage ? matchedStage.stageName : item.name  // fallback if not found
      //   };
      // });

      // const updated = transformedData
      // const updated = [
      //   [
      //     "7",
      //     4
      //   ]
      // ]

      return {
        chart: {
          type: 'funnel',
          // height: '100%',
        },
        title: false,
        plotOptions: {
          series: {
            colors,
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b> ({point.y:,.0f})',
              softConnector: true
            },
            center: ['40%', '50%'],
            neckWidth: '30%',
            neckHeight: '25%',
            width: '80%',
            states: {
              // hover: {
              //   brightness: 0, // no change in brightness
              // }, 
              inactive: {
                enabled: false // 🔥 disables dimming of other segments
              }
            }
          },
        },
        tooltip: {
          useHTML: true,
          backgroundColor: 'transparent',
          borderWidth: 0,
          shadow: false,
          formatter: function () {
            return `<div class="custom-tooltip" style="border-color: ${this.point.color}">
              <div class="tooltip-content">
                <div><strong>${this.series.name}</strong></div>
                <div><strong>${this.point.name}</strong>: ${this.y}</div>
              </div>
            </div>`;
          }
        },
        legend: {
          enabled: false
        },
        series: [{
          // name: 'Unique users',
          name: '',
          data: updated?.length > 0 ? updated : [],
          // data: transformedData
        }],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 500
            },
            chartOptions: {
              plotOptions: {
                series: {
                  dataLabels: {
                    inside: true
                  },
                  center: ['50%', '50%'],
                  width: '100%'
                }
              }
            }
          }]
        }
      }
    }
  }
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
    .custom-tooltip {
      position: relative;
      background-color: #fff;
      border: 2px solid;
      padding: 4px 12px 8px;
      border-radius: 6px;
      color: #333;
      // text-align: center;
      box-sizing: border-box;
    }
    .custom-tooltip::after {
      content: '';
      width: 10px;
      height: 10px;
      position: absolute;
      bottom: -6px;
      left: 50%;
      transform: translateX(-50%) rotate(45deg);
      margin-top: -5px;
      background-color: #ffffff;
      border-width: 0px 2px 2px 0;
      border-style: solid;
      border-color: inherit;
      border-top-color: inherit;
    }
  `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);
  let [funnelChartOptions, setFunnelChartOptions] = useState(getOptions([]));
  let { subModuleData, isDashboardLoading } = useSelector((state) => state?.dashboardComponents);
  let [countData, setCountData] = useState([]);
  let [groupingData, setGroupingData] = useState([]);
  let [width, setWidth] = useState("0%");

  useEffect(() => {
    if (countData?.length > 0 && groupingData?.length > 0 && !isStatic) {
      let valueNumber = 0;
      let formatGroupingData = groupingData?.filter(x => x !== "None");
      let isNone = groupingData?.some(x => x === "None");
      let formatCountData = countData?.filter((_, index) => groupingData[index] !== "None");
      let noneCountData = countData?.filter((_, index) => groupingData[index] === "None");
      let sumCheck = (operation, values) => {
        switch (operation) {
          case 'sum':
            return values.length ? values.reduce((total, val) => total + val, 0) : 0;
          case 'min':
            return values.length ? Math.min(...values) : 0;
          case 'max':
            return values.length ? Math.max(...values) : 0;
          case 'average':
            return values.length ? values.reduce((total, val) => total + val, 0) / values.length : 0;
          default:
            return 0;
        }
      }
      let yAxisMeasure = data?.y_axis_measure;
      if (isNone) {
        if (yAxisMeasure?.startsWith("Count of - ")) {
          valueNumber = noneCountData?.reduce((total, num) => total + num, 0);
        } else if (yAxisMeasure?.startsWith("Sum of ")) {
          valueNumber = sumCheck('sum', noneCountData)
        } else if (yAxisMeasure?.startsWith("Minimum of ")) {
          valueNumber = sumCheck('min', noneCountData)
        } else if (yAxisMeasure?.startsWith("Maximum of ")) {
          valueNumber = sumCheck('max', noneCountData)
        } else if (yAxisMeasure?.startsWith("Average of ")) {
          valueNumber = sumCheck('average', noneCountData)
        }
      }
      let seriesData = [...formatCountData, ...(isNone ? [valueNumber] : [])];
      let xAxisData = [...formatGroupingData, ...(isNone ? ['None'] : [])];
      let { uniqueItems, aggregatedCounts } = Utils.removeDuplicatesAndTotalCount(xAxisData, seriesData);
      let { labels, values } = Utils.chartFormatDatas(data?.grouping, uniqueItems, aggregatedCounts, data?.grouping_type, "funnel");
      let result = labels?.map((name, index) => ({
        name: name,
        id: name,
        value: values?.[index],
      }));
      setFunnelChartOptions(getOptions(result));
      setTimeout(() => {
        setWidth("100%");
      }, 100);
    } else if (!isStatic) {
      setFunnelChartOptions(getOptions([], []));
    }
  }, [countData, groupingData]);

  useEffect(() => {
    if (subModuleData?.[data?.moduleId]?.length > 0 && Object?.keys(data)?.length > 0 && !isStatic) {
      let datas = [...(subModuleData?.[data?.moduleId] || [])].reverse();
      let checkGrouping = ["day", "month", "year", "Created_At"];
      let newFilteredData = Utils.filteredDataGet(datas, data);
      let yAxisMeasure = data?.y_axis_measure;
      let grouping = Helpers.replaceData(data?.grouping);
      let formattedDate = (date) => dayjs(date).format("YYYY-MM-DD");
      let calculate = (label, isGrouping = false) => {
        let values = newFilteredData?.map(record => {
          let value = isGrouping ? 'None' : 0;
          if (isGrouping && checkGrouping?.includes(label)) {
            value = formattedDate(record?.createdAt);
          } else {
            for (let section of record?.data || []) {
              if (section?.section_data?.[label] !== undefined) {
                if (isGrouping && data?.grouping_type === "user") {
                  value = section.section_data[label]?.name?.toString()?.trim() || 'None';
                } else if (isGrouping) {
                  value = section.section_data[label]?.toString()?.trim() || 'None';
                  value = (data?.grouping_type === "date" && value !== "None") ? formattedDate(value) : value;
                } else {
                  value = parseFloat(section.section_data[label]) || 0;
                }
                break;
              }
            }
          }
          return value;
        });
        return values || [];
      };

      let getLabel = (prefix) => Helpers.replaceData(yAxisMeasure?.replace(new RegExp(`^${prefix} of `), ''));

      if (yAxisMeasure?.startsWith("Count of - ")) {
        setCountData(Array(newFilteredData?.length || 0).fill(1));
      } else if (yAxisMeasure?.startsWith("Sum of ")) {
        let label = getLabel("Sum");
        setCountData(calculate(label));
      } else if (yAxisMeasure?.startsWith("Minimum of ")) {
        let label = getLabel("Minimum");
        setCountData(calculate(label));
      } else if (yAxisMeasure?.startsWith("Maximum of ")) {
        let label = getLabel("Maximum");
        setCountData(calculate(label));
      } else if (yAxisMeasure?.startsWith("Average of ")) {
        let label = getLabel("Average");
        setCountData(calculate(label));
      }
      setGroupingData(calculate(grouping, true));
    } else if (!isStatic) {
      setFunnelChartOptions(getOptions([], []));
    }
  }, [subModuleData?.[data?.moduleId], data]);

  useEffect(() => {
    if (isStatic) {
      let names = ['Series A', 'Series B', 'Series C', 'Series D', 'Series E'];
      let values = [60, 40, 20, 80, 100];
      let result = names.map((name, index) => ({
        name: name,
        value: values[index],
      }));
      setFunnelChartOptions(getOptions(result));
      setTimeout(() => {
        setWidth("100%");
      }, 100);
    }
  }, [isStatic]);

  const _data = [
    { id: "Sent", value: 100 },
    { id: "Viewed", value: 80 },
    { id: "Clicked", value: 50 },
    { id: "Converted", value: 20 }
  ];
  console.log("funnelChartOptions", funnelChartOptions);

  const funnelData = funnelChartOptions?.series?.[0]?.data?.map(([name, count]) => ({
    id: name,
    label: name,
    value: count,
  }));
  return (
    <>
      {isDashboardLoading && !funnelChartOptions?.series?.[0]?.data?.length ?
        <div className='chart-loader'><Loader type={'infinitySpin'} isVisible={true} /></div>
        :
        <>
          {funnelChartOptions?.series?.[0]?.data?.length > 0 ? (
            // <ReactEcharts option={funnelChartOptions} style={{ height: "100%", width: width }} />
            <div className='justify-content-center vstack h-100 align-items-center'>
              {/* <HighchartsReact containerProps={{
                style: {
                  height: "75%",
                  width: "80%",
                  margin: "auto 0"
                }
              }}
                highcharts={Highcharts}
                options={funnelChartOptions}
              /> */}
              <div style={{ height: 400, width: "100%" }}>
                <ResponsiveFunnel
                  data={funnelData}

                  margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
                  // valueFormat=">-.4s"
                  enableLabel={true}
                  label={(d) => d.label}
                  labelPosition="inside"
                  colors={{ scheme: 'spectral' }}
                  borderWidth={20}
                  labelColor={{ from: 'color', modifiers: [['darker', 3]] }}
                  beforeSeparatorLength={100}
                  beforeSeparatorOffset={20}
                  afterSeparatorLength={100}
                  afterSeparatorOffset={20}
                  currentPartSizeExtension={10}
                  currentBorderWidth={40}

                // margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
                // enableLabel={true}
                // label={(d) => d.label}
                // labelPosition="inside"
                // labelColor={{ from: "color", modifiers: [["darker", 3]] }}
                // colors={{ scheme: "spectral" }}
                // borderWidth={2}
                // beforeSeparatorLength={40}
                // afterSeparatorLength={40}
                // currentPartSizeExtension={10}
                // motionConfig="gentle"
                />
              </div>
            </div>
          ) : (
            <div className='h-100 text-secondary align-self-center align-center py-3'>No Data Found</div>
          )}
        </>
      }
    </>
  )
};

// new chart
// const FunnelChart = ({ data = {}, isStatic = false }) => {
//   const option = {
//     title: {
//       text: "Sales Funnel",
//       subtext: "Example Data",
//       left: "center"
//     },
//     tooltip: {
//       trigger: "item",
//       formatter: "{a} <br/>{b} : {c}%"
//     },
//     legend: {
//       bottom: 0,
//       data: ["Visit", "Inquiry", "Order", "Payment", "Delivery"]
//     },
//     series: [
//       {
//         name: "Funnel",
//         type: "funnel",
//         left: "10%",
//         top: 60,
//         bottom: 60,
//         width: "80%",
//         min: 0,
//         max: 100,
//         minSize: "0%",
//         maxSize: "100%",
//         sort: "descending",
//         gap: 2,
//         label: {
//           show: true,
//           position: "inside"
//         },
//         labelLine: {
//           length: 10,
//           lineStyle: {
//             width: 1,
//             type: "solid"
//           }
//         },
//         itemStyle: {
//           borderColor: "#fff",
//           borderWidth: 1
//         },
//         emphasis: {
//           label: {
//             fontSize: 18
//           }
//         },
//         data: [
//           { value: 100, name: "Visit" },
//           { value: 80, name: "Inquiry" },
//           { value: 60, name: "Order" },
//           { value: 40, name: "Payment" },
//           { value: 20, name: "Delivery" }
//         ]
//       }
//     ]
//   };

//   return (
//     <div style={{ width: "100%", height: "400px" }}>
//       <ReactECharts option={option} style={{ height: "100%" }} />
//     </div>
//   );
// }

export default FunnelChart;